import React from "react"
import { Box, Container, Grid, Heading } from "@chakra-ui/react"
import ProductCard from "@components/Product/ProductCard"
import TileCarousel from "@components/TileCarousel/TileCarousel"
import { useShopifyProductLive, useShopifyProductRaw } from "@hooks/useShopify"
import { useMedia } from "@hooks/useMedia"
import { Location } from "@root/types/global"

const ProductCompleteLook = ({ related, location }: { related: GatsbyTypes.SanityProduct[]; location: Location }) => {
  const carouselSettings = {
    enableScrollbar: true,
    enableNavigation: true,
  } as GatsbyTypes.SanityCarouselSettings
  const { isBase } = useMedia()

  const isActiveProduct = product => {
    return product?.shopify?.published === true
  }
  const filteredProducts = related.filter(isActiveProduct)

  return (
    <Box bg="brand.beige.dark" as="section">
      <Box py={2.5}>
        <Heading as="h2" size="h2" mb={2.5} textAlign="center">
          {`Complete The Look`}
        </Heading>
        <Container
          minWidth={`unset`}
          maxWidth={`container.xl`}
          pl={3}
          overflow={`hidden`}
          sx={{
            ".swiper": { overflow: `visible` },
            maxWidth: filteredProducts?.length == 2 ? "860px" : filteredProducts?.length == 1 ? "430px" : `container.xl`,
          }}
        >
          {!isBase ? (
            <Grid templateColumns={`repeat(${filteredProducts?.length}, 1fr)`} gap={2}>
              {related?.map((product: any) =>
                product?.shopify?.published === true ? <RelatedItem product={product} key={product?.id} location={location} /> : null
              )}
            </Grid>
          ) : (
            <TileCarousel
              carouselSettings={carouselSettings}
              slidesPerView={3}
              spaceBetweenTiles={10}
              navigationProps={{ top: "32%", bg: "brand.primary", color: "black" }}
            >
              {related?.map((product: any) =>
                product?.shopify?.published === true ? <RelatedItem product={product} key={product?.id} location={location} /> : null
              )}
            </TileCarousel>
          )}
        </Container>
      </Box>
    </Box>
  )
}

export default React.memo(ProductCompleteLook)

export const RelatedItem = ({
  product,
  location,
  onQuickView,
}: {
  product: GatsbyTypes.SanityProduct
  location: Location
  onQuickView?: () => void
}) => {
  const { product: rawProduct } = useShopifyProductRaw(product)
  const { product: liveProduct } = useShopifyProductLive(rawProduct)
  const item = liveProduct || rawProduct

  const isStl = product?.tags?.includes(`stl`)

  return (
    <Box mb="0" minWidth={{ base: "68vw", md: `full` }} maxWidth="255px">
      <ProductCard
        isStl={isStl}
        fullSize={true}
        key={item?.id}
        item={item}
        location={location}
        wishlistSize="sm"
        onQuickView={onQuickView}
      />
    </Box>
  )
}
